import axios from 'axios';

let restApiInvoice = axios.create({
    baseURL: 'https://portalalgoritampn.in.rs/',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    }
});

restApiInvoice.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

restApiInvoice.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        return Promise.reject(error.response);
    }
);

export default restApiInvoice



// WEBPACK FOOTER //
// ./src/http-common-delivery.js